import styled from 'styled-components';
import { BREAKPOINT_SMALL } from 'client/components/MarketingPagesShared/styles';

export const MarketingFAQContainer = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 150px 24px;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 100px 24px;
  }
`;

export const MarketingFAQDetails = styled.details`
  width: 100%;
  max-width: 790px;
  margin-bottom: 50px;
  padding-left: 30px;
  font-size: 1.125rem;
  line-height: 30px;
`;

export const MarketingFAQSVG = styled.svg`
  position: absolute;
  top: 8px;
  left: -28px;
  margin-right: 15px;
`;

export const MarketingFAQSummary = styled.summary`
  position: relative;
  font-weight: bold;
  cursor: pointer;
  &::-webkit-details-marker {
    display: none;
  }
`;

export const MarketingFAQTitle = styled.h2`
  margin: 0 0 50px;
  font-weight: 900;
  font-size: 2.25rem;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    font-size: 1.75rem;
  }
`;
